export default __webpack_public_path__ + "static/media/ads5.74db8ac1.jpg";